import AppStoreBadges from 'elements/AppStoreBadges';

export default function AppDownload() {
    return (
        <div className='w-full flex-1 flex bg-cover bg-center bg-no-repeat' style={{ backgroundImage: 'url(/assets/images/background/app_download.png)' }}>
            <div className='w-full flex-1 flex items-center bg-black/50 px-5 py-10 sm:px-8 md:px-12 md:py-14 lg:px-16 xl:px-20'>
                <div className='flex w-full max-w-3xl flex-col items-center gap-5 text-center sm:items-start sm:text-left md:gap-7'>
                    <h1 className='w-full font-display text-4xl font-black leading-none text-white sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl'>FürgeDiák App</h1>
                    <p className='max-w-2xl text-sm leading-relaxed text-gray-200 sm:text-base md:text-lg lg:text-xl'>
                        <span className='block'>Töltsd le a FürgeDiák alkalmazását!</span>
                        <span className='mt-1 block'>Értesülj a legtrendibb módon új munkalehetőségeinkről.</span>
                    </p>
                    <p className='w-full font-display text-xl font-bold leading-tight text-white sm:text-2xl md:text-3xl lg:text-4xl'>Jelentkezz egy kattintással!</p>
                    <AppStoreBadges className='mt-1 justify-center sm:justify-start' />
                </div>
            </div>
        </div>
    );
}
